function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #757575;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_3",
  "data-name": "Trazado 3",
  className: "cls-1",
  d: "M984.722,210.606l-4.127-13.415a3.1,3.1,0,0,0-6.07.913v1.451h-2.277V198.1a3.1,3.1,0,0,0-6.07-.913l-4.127,13.415a1.148,1.148,0,0,0-.05.335v.569a5.124,5.124,0,1,0,10.247,0v-5.124h2.277v5.124a5.124,5.124,0,0,0,10.248,0v-.569A1.144,1.144,0,0,0,984.722,210.606Zm-17.6,3.751a2.847,2.847,0,1,1,2.847-2.847A2.85,2.85,0,0,1,967.124,214.356Zm12.525,0a2.847,2.847,0,1,1,2.847-2.847A2.851,2.851,0,0,1,979.648,214.356Z",
  transform: "translate(-962 -195)"
});

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.772,
    height: 21.634,
    viewBox: "0 0 22.772 21.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.92416608.svg";
export { ForwardRef as ReactComponent };